var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_2482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20ZM11.0588 9.81875C11.7516 9.5695 12.3342 9.08381 12.7041 8.4472C13.074 7.81059 13.2075 7.06388 13.081 6.33854C12.9545 5.61321 12.5761 4.95577 12.0125 4.48197C11.449 4.00818 10.7363 3.74841 10 3.74841C9.26372 3.74841 8.55104 4.00818 7.98746 4.48197C7.42387 4.95577 7.04552 5.61321 6.91901 6.33854C6.7925 7.06388 6.92596 7.81059 7.29587 8.4472C7.66578 9.08381 8.24844 9.5695 8.94125 9.81875C6.83875 10.3263 5 12.2188 5 13.75C5 14.2437 5.18125 14.9937 6.25 14.9937H13.75C14.8188 14.9937 15 14.2437 15 13.75C15 12.22 13.1625 10.325 11.0588 9.81875Z",
    fill: "url(#paint0_linear_227_2482)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_2482",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#982815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7878"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_2482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9fe9433d2f9077625dc6b1a4baf9a52c.svg";
export { ForwardRef as ReactComponent };